import { FC, ReactElement } from 'react'
import info from '../../assets/icons/info2.svg'
import { Container } from './style'

type InformationPopupProps = {
  content: string | ReactElement;
}

const InformationPopup: FC<InformationPopupProps> = ({ content }): ReactElement => {
  return (
    <Container>
      <div className='information_popup_content_info'>
        {content}
        <div className='arrow_down' />
      </div>
      <img src={info} alt='info' />
    </Container>
  )
}

export default InformationPopup
